// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import messages from './js/messages'
import common from './js/common'

if (!common.isSmartPhone()) {
  document.querySelector('#common').href = './resources/pc/css/common.css'
  document.querySelector('#style').href = './resources/pc/css/style.css'
  document.querySelector('#style_nf').href = './resources/pc/css/style_nf.css'
}

let mainDisp = function () {
  document.querySelector('#mainDiv').style.display = 'unset';
}
setTimeout(mainDisp, 500);



Vue.component('v-select', vSelect)

Vue.config.productionTip = false

//ブラウザバック禁止
history.pushState(null, null, null);//リロード対応 リロード時に申し込みサイトに遷移する前の画面に戻るように制御
window.addEventListener("popstate", function () {
  history.pushState(null, null, null);//直近に履歴を追加することで、ブラウザバック時、常にpopstateイベントを発火させる
  router.push(router.history.current.fullPath).catch(() => { })//ブラウザバック時にrouterによる遷移先を自身の画面に設定
  return;
});

// グローバル変数を定義する
let GlobalData = new Vue({
  data() {
    return {
      errorFlg: false, // グローバル変数
      msg: [],
      showClass: ''//画面遷移時のアニメーションパターン
    }
  }
});

// mixin でグローバル変数をラッピングする
Vue.mixin({
  created() {
    //メッセージ読み込み
    GlobalData.$data.msg = messages.MESSAGES

    //初期表示時スクロール位置をトップにする
    common.setscrollTop()
  },
  mounted() {
    //ヘッダ部のアクティブ表示切替
    common.headerActiveSwitching(this)

    //遷移先の画面に画面遷移時のアニメーションのCSSを充てる(次へと戻るで異なるCSSを充てる)
    if (typeof this.$options.parent === "undefined") { return }
    if (this.$options.parent.isBack) {
      GlobalData.$data.showClass = common.constant.SHOW_PREV
    } else {
      GlobalData.$data.showClass = common.constant.SHOW_NEXT
    }

    this.$options.parent.isBack = false

    // 申込書表示判定
    common.isApplicationForm(this)
  },
  methods: {
    // 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
    errorFlg() {
      return GlobalData.$data.errorFlg
    },
    setErrorFlg(newErrorFlg) {
      GlobalData.$data.errorFlg = newErrorFlg;
    },
    setShowClass(newShowClass) {
      GlobalData.$data.showClass = newShowClass;
    },
    getShowClass() {
      return GlobalData.$data.showClass
    }

  },
  computed: {
    // 各コンポーネント内の<template>タグ内でグローバル変数を参照するための処置
    $errorFlg: {
      get: function () { return GlobalData.$data.errorFlg },
      set: function (newErrorFlg) { GlobalData.$data.errorFlg = newErrorFlg; }
    },
    $msg: {
      get: function () { return GlobalData.$data.msg }
    },
  }
})

// 例外エラーハンドリング
Vue.config.errorHandler = function (err) {
  console.log(err)
  alert(GlobalData.$data.msg.ERROR.MSG_9997)
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render(h) {
    return h(App);
  }
})
